import { styled } from "@linaria/react"

import { Horizontal, Spring } from "@/components/Flex.ts"
import { INPUT_HEIGHT_PX } from "@/components/Input/Input.tsx"
import {
  SelectContent,
  SelectIcon,
  SelectItem,
  SelectItemText,
  SelectPortal,
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectViewport
} from "@/components/Select/Select.tsx"
import { ChevronDownLight, GithubFill, Icon20 } from "@/icons/Icons.ts"

import type { GitHubAccountInfo } from "@/lib/client/generated/TypeDefinitions"

export const GitHubAccountSelector = ({ accounts, selectedAccount, onAccountChange }: {
  accounts: GitHubAccountInfo[]
  selectedAccount: GitHubAccountInfo | undefined
  onAccountChange: (login: string | null) => void
}) => {
  const currentValue = selectedAccount?.login || accounts[0]?.login || ""

  return (
    <SelectRoot
      value={currentValue}
      onValueChange={(value) => {
        onAccountChange(value || null)
      }}
    >
      <GitHubSelectTrigger>
        <Horizontal alignItems="center" gap="8px">
          {selectedAccount?.avatarUrl ? (
            <AccountAvatar src={selectedAccount.avatarUrl} alt={selectedAccount.login} />
          ) : (
            <GithubFill className={Icon20} />
          )}
          <SelectValue placeholder="Select account" />
          <Spring />
          <SelectIcon><ChevronDownLight className={Icon20} /></SelectIcon>
        </Horizontal>
      </GitHubSelectTrigger>

      <SelectPortal>
        <GitHubSelectContent>
          <SelectViewport>
            {accounts.map((account) => (
              <InstallationItemContent key={account.login} value={account.login}>
                <AccountItemContent>
                  {account.avatarUrl ? (
                    <AccountAvatar src={account.avatarUrl} alt={account.login} />
                  ) : (
                    <GithubFill className={Icon20} />
                  )}
                  <SelectItemText>
                    {account.login}
                  </SelectItemText>
                </AccountItemContent>
              </InstallationItemContent>
            ))}
          </SelectViewport>
        </GitHubSelectContent>
      </SelectPortal>
    </SelectRoot>
  )
}

const GitHubSelectTrigger = styled(SelectTrigger)`
  border-radius: var(--border-radius-12);
`

const GitHubSelectContent = styled(SelectContent)`
  border-radius: var(--border-radius-12);
`

const InstallationItemContent = styled(SelectItem)`
  display: flex;
  align-items: center;
  height: ${INPUT_HEIGHT_PX}px;
`

const AccountItemContent = styled(Horizontal)`
  align-items: center;
  gap: 8px;
  flex: 1;
`

const AccountAvatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
`
